// extracted by mini-css-extract-plugin
export default {"complete-appointment-modal-dialog":"CompleteRequest_complete-appointment-modal-dialog__YxS4V"};